import { cn } from "../../../../lib/utils";

/** Scoped layout / link styles for the PAF route page shell. */
export const PAF_PAGE_CLASS = cn(
  "min-h-screen w-full bg-[#f8f8f8] pt-[60px] pb-[30px] overflow-y-auto px-[100px]",


);
